module.exports = __webpack_public_path__ + "static/img/5.af54712.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solu/5.png
// module id = KXaU
// module chunks = 0